<template>
  <div class="generalPage">
    <isotopegrid v-bind:isotopeProps="isotopeProps"></isotopegrid>
    <!--div class="isotopeGrid">
      <div class="section2">
        <div class="generalWrapper">
          <h1>如何消滅它們</h1>
          <p>要徹底消滅家中的甲甴，關鍵是消滅整個曱甴巢內的曱甴。 如果只是殺死眼前的曱甴，其餘的會繼續在家中出末覓食，尋找食物和水源。它們會繼續繁殖，變得愈來愈多，巢穴會愈來愈大。</p>
          <p>威滅速效曱甴藥餌可以將巢穴內的曱甴一網打盡。想了解更多有關威滅一網打盡的原理，請按這裡。</p>
        </div>
      </div>
    </div-->
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isotopeProps: {
        title: '曱甴小常識',
        desc: '害蟲種類及資訊',
        cardname: '曱甴小常識',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '美洲曱甴',
          id: 0,
          imgpath: '',
          _imgpath: require('../assets/pi-roach-cover-american.jpg'),
          tag: '',
          cardname: '種類',
          html: `
            <h1 class="hdr">美洲曱甴</h1>
            <h1>居住地</h1>
            <p>美洲曱甴為香港常見的曱甴，一般出現在下水道、渠道等潮濕的地方。</p>
            <h1>外表</h1>
            <p>美洲曱甴是最大的家居曱甴。成年的美洲曱甴長約3.8厘米至5厘米，有紅棕色翅膀，在淺色背上有深色標記。它們可以擠進只有3mm厚的空間。</p>
            <h1>關於美洲曱甴：</h1>
            <ul>
              <li>美洲曱甴可以飛行。</li>
              <li>雌性美洲曱甴每年可以繁殖多達150個後代。</li>
              <li>它們的行動速度很快，每秒可以行走約50個身體長度（相當於人類每小時跑330公里)。</li>
              <li>它們一般在夜間時份比較活躍。</li>
              <li>它們什麼都吃，包括紙，頭髮，布和蟲類屍體。</li>
            </ul>
          `
        }, {
          name: '德國曱甴',
          id: 1,
          imgpath: '',
          _imgpath: require('../assets/pi-roach-cover-german.jpg'),
          tag: '',
          cardname: '種類',
          html: `
            <h1 class="hdr">德國曱甴</h1>
            <h1>居住地</h1>
            <p>德國曱甴一般在家居和商業場所生活和繁殖。</p>
            <h1>外表</h1>
            <p>德國曱甴是小曱甴，成年德國曱甴只長約1.2厘米。  它們呈黃棕色/棕色，頭部的背上有兩條縱向的黑色條紋。</p>
            <h1>關於德國曱甴:</h1>
            <ul>
              <li>雖然德國曱甴有翅膀，但它們不會飛行。</li>
              <li>一隻雌性德國曱甴一年可以繁殖多達10萬個後代，是所有害蟲種類中最快的。</li>
              <li>新生的德國曱甴在36天內會成為成年曱甴。</li>
              <li>它們普遍會吃甜食，油脂，肉和垃圾。</li>
            </ul>
          `
        }, {
          name: '棕帶曱甴',
          id: 2,
          imgpath: '',
          _imgpath: require('../assets/pi-roach-cover-brownbanded.jpg'),
          tag: '',
          cardname: '種類',
          html: `
            <h1 class="hdr">棕帶曱甴</h1>
            <h1>居住地</h1>
            <p>棕帶曱甴一般出現在家居，公寓，酒店和辦公室。</p>
            <h1>外表</h1>
            <p>棕帶曱甴比較細小，成年的長約1.2厘米。它們的背部有兩條部份/完全被翅膀遮蓋的淺黃色條紋。</p>
            <h1>關於棕帶曱甴:</h1>
            <ul>
              <li>它們會在溫暖、乾燥的氣候中更常見。</li>
              <li>據報導，棕帶曱甴能傳播至少33種細菌、6種寄生蟲和至少7種人類病原體。</li>
              <li>它們一般在夜間時份比較活躍。</li>
              <li>它們會吃家庭用品，如書籍，信封，郵票，壁紙和布。</li>
            </ul>
          `
        }, {
          name: '防止曱甴入侵的方法',
          id: 3,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">防止曱甴入侵的方法</h1>
            <p>堵塞外牆上的裂縫，並在下水道中安裝篩網，有助限制曱甴的活動。</p>
            <p>改善衛生、減少雜亂、清除積水是防止曱甴入侵的有效方法。</p>
            <p>清除枯萎的植物和減少潮濕的環境，以防止曱甴繁殖和築巢。隨著巢穴減少，曱甴數量亦將會縮少。</p>
          `
        }, {
          name: '築巢地點',
          id: 4,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">築巢地點</h1>
            <h1>美洲曱甴</h1>
            <p>一般在戶外生活和繁殖，進入家裡尋找食物和水源。 它們喜歡溫暖和潮濕環境，可以通過排水管和排污管進入家中。</p>
            <h1>德國曱甴</h1>
            <p>繁殖迅速，它們喜歡陰暗隱蔽的地方，如櫥櫃底部和冰箱後面。在商業大廈中，德國曱甴經常出現在紙箱，木箱或托盤下面。</p>
            <h1>棕帶曱甴</h1>
            <p>喜歡較高的位置，如天花板，高身牆壁和相框後面。 它們相對需要較少的水分，所以通常不在廚房和浴室出末，但喜歡在雪櫃或其他電器、家具內築巢。</p>
          `
        }, {
          name: '如何消滅它們',
          id: 5,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">如何消滅它們</h1>
            <p>要徹底消滅家中的甲甴，關鍵是消滅整個曱甴巢內的曱甴。 如果只是殺死眼前的曱甴，其餘的會繼續在家中出末覓食，尋找食物和水源。它們會繼續繁殖，變得愈來愈多，巢穴會愈來愈大。</p>
            <p>威滅速效曱甴藥餌可以將巢穴內的曱甴一網打盡。想了解更多有關威滅一網打盡的原理，<a href="#/preventiontips/insecticideguide">請按這裡</a>。</p>
          `
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function () {
              return true
            },
            '螞蟻': function (el) {
              return el.tag.match(/螞蟻$/)
            },
            '曱甴': function (el) {
              return el.tag.match(/曱甴$/)
            }
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_isotopeGridContents.sass"
</style>



// WEBPACK FOOTER //
// PICockroach.vue?5c1b72be